// Palette mirrors the prototype's fitracking-style tokens.
export const NEUTRAL = '#f3f3f2';
export const INK = '#000000';
export const GRAY = '#737373';
export const MUTED = '#bebebb';
export const LINE = '#e5e5e4';
export const YELLOW = '#fffa01';
export const SURFACE = '#ffffff';
/** Soft radial "spotlight" behind product renders. */
export const SPOTLIGHT = 'radial-gradient(55.5% 55.5% at 50% 50%, #ffffff 45%, #ebe8e6 100%)';

export const MOBILE = '@media (max-width: 720px)';
export const TABLET = '@media (max-width: 1000px)';

/** Responsive column template shared by the sticky selector bar and the comparison
 * matrix — 2px hairline column gaps; 3 columns on desktop, 2 on mobile. */
export const GRID_TEMPLATE = {
  display: 'grid' as const,
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  columnGap: 2,
  [MOBILE]: { gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' },
};
